import { AnyAction, Dispatch } from 'redux';

export const TOGGLE_CAMERA = 'camera.TOGGLE_CAMERA';
export const toggleCamera: ToggleCamera = mounted => dispatch => {
  dispatch({ payload: mounted, type: TOGGLE_CAMERA });
};

// export type Resolve<T> = (value?: T | PromiseLike<T>) => void;

export type ToggleCamera = (
  mounted: boolean,
) => (dispatch: Dispatch<AnyAction>) => void;



// WEBPACK FOOTER //
// ./src/store/actions/cameraActions.ts